/* Generated by scripts/sync-ai-lab-theme.mjs. Source: ai-lab-shopify/js/tracking.js */
(function () {
  'use strict';

  if (window.AILabTrackingFactory) return;

  function createTracker(config) {
    var CONFIG = config || {};
      var API_URL = CONFIG.apiUrl || 'https://aichat.smartfeaturehub.com/tracking/report';
      var SOURCE = CONFIG.source || 'ailab';
      var SESSION_ID = 'sess_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8);
      var PAGE_START_TIME = Date.now();
      var PRODUCT_ID = '';
      try {
        var searchParams = new URLSearchParams(location.search);
        PRODUCT_ID = searchParams.get('product_id') || '';
      } catch (e) {}
    
      // 页面加载时快照 userId，避免同一设备不同用户之间互相污染
      var SNAPSHOT_USER_ID = '';
      try { SNAPSHOT_USER_ID = localStorage.getItem('userId') || ''; } catch (e) {}
    
      function clip(value, max) {
        return String(value == null ? '' : value).slice(0, max);
      }
    
      function getUserId(useSnapshot) {
        if (useSnapshot) return SNAPSHOT_USER_ID;
        try { return localStorage.getItem('userId') || ''; } catch (e) { return ''; }
      }
    
      function getCommonFields(useSnapshotUserId) {
        return {
          session_id: SESSION_ID,
          page: clip(location.href, 512),
          user_agent: clip(navigator.userAgent, 512),
          screen: clip(screen.width + 'x' + screen.height, 32),
          language: clip(navigator.language || '', 16),
          referrer: clip(document.referrer || '', 512),
          source: SOURCE,
          user_id: getUserId(useSnapshotUserId),
          product_id: PRODUCT_ID
        };
      }
    
      function track(eventKey, eventData, eventType, stEd, duration, useSnapshotUserId) {
        var payload = {};
        // 默认实时读最新 userId；事件1（enter/leave）传 true 用快照
        var useSnapshot = !!useSnapshotUserId;
        var common = getCommonFields(useSnapshot);
        for (var k in common) {
          if (Object.prototype.hasOwnProperty.call(common, k)) payload[k] = common[k];
        }
        payload.event_type = (eventType != null) ? eventType : null;
        payload.event = eventKey;
        payload.data = eventData || {};
        payload.st_ed = (stEd != null) ? stEd : null;
        payload.duration = (duration != null) ? duration : 0;
        payload.timestamp = Date.now();
    
        var json = JSON.stringify(payload);
    
        // keepalive 保证页面卸载(离开页面/进入聊天)时请求仍能发完。
        // 不用 sendBeacon: 跨域发 application/json 会触发预检，sendBeacon 排队即返回 true
        // 但实际 body 常发不出去，且不回退，导致丢数据。
        try {
          fetch(API_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: json,
            keepalive: true,
            mode: 'cors'
          }).catch(function () {});
        } catch (e) {}
      }
    
      function getSessionId() {
        return SESSION_ID;
      }
    
      function getPageStartTime() {
        return PAGE_START_TIME;
      }
    
      function getProductId() {
        return PRODUCT_ID;
      }
    
      return {
          track: track,
          getSessionId: getSessionId,
          getPageStartTime: getPageStartTime,
          getProductId: getProductId,
          SOURCE: SOURCE
        };
  }

  window.AILabTrackingFactory = { create: createTracker };
})();
